import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Lifestyle%20product%20photography%20with%20sneakers%20streetwear%20hoodies%20caps%20and%20accessories%20artfully%20arranged%20on%20light%20cream%20surfaces%20soft%20diffused%20natural%20window%20lighting%20editorial%20composition%20warm%20beige%20and%20cream%20tones%20gentle%20shadows%20modern%20minimal%20aesthetic%20harmonious%20product%20display%20high%20resolution&width=1920&height=1080&seq=hero-main-2026&orientation=landscape"
        alt="OOPBuy Spreadsheet Produkte"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-6xl mx-auto text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-semibold tracking-wider uppercase bg-accent-500/90 text-background-50 rounded-full">
            OOPBuy Spreadsheet Guide 2026
          </span>
        </div>

        <h1 className="animate-fade-in-up animation-delay-200 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 md:mb-8">
          OOPBuy Spreadsheet<br />
          <span className="text-accent-400">Finde die besten Produkte schneller</span>
        </h1>

        <p className="animate-fade-in-up animation-delay-400 text-sm md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Der komplette deutsche Guide für OOPBuy Spreadsheet.
          Entdecke Produktlisten, Kategorien, Bewertungen, Sicherheitstipps und Schritt-für-Schritt Anleitungen.
        </p>

        <div className="animate-fade-in-up animation-delay-600 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            oopbuy spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </span>
          </a>
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-semibold border-2 border-background-200/60 text-background-50 rounded-md hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            OOPBuy Anleitung lesen
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="mt-12 md:mt-16 flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {[
            { icon: 'ri-check-line', text: 'Über 100+ Guides' },
            { icon: 'ri-file-list-3-line', text: 'Aktualisierte Spreadsheet Listen' },
            { icon: 'ri-global-line', text: 'Deutsche Erklärung' },
            { icon: 'ri-shield-check-line', text: 'Sicherheitsorientierte Infos' },
          ].map((item, i) => (
            <div
              key={i}
              className="animate-fade-in-up flex items-center gap-2 text-background-200/80 text-sm"
              style={{ animationDelay: `${0.8 + i * 0.15}s`, opacity: 0 }}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-accent-400`}></i>
              </span>
              {item.text}
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#was-ist" className="text-background-200/70 hover:text-background-50 transition-colors cursor-pointer">
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-xl"></i>
          </span>
        </a>
      </div>
    </section>
  );
}